import React from 'react';
import { Icon, IconComponent } from './icon';
import src from 'grpn-mx-mixer/dist/images/icons/phone.svg';

export const IconPhone: IconComponent = props => <Icon {...props} src={src} />;
